const __WEBPACK_NAMESPACE_OBJECT__ = require("@ansugroup/timing-safe-equal");